import React from 'react';
import SvgIcon from './SvgIcon';

const Organization = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M19.5 17.75a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM23.25 22.25c0-2.813-1.688-4.5-3.75-4.5-2.063 0-3.75 1.688-3.75 4.5h7.5zM4.5 17.75a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM8.25 22.25c0-2.813-1.688-4.5-3.75-4.5-2.063 0-3.75 1.688-3.75 4.5h7.5zM16 15l-2-3m-6 3l2-3m5 5.5H9M11.95 5.5a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM11.95 6a3.73 3.73 0 00-2.642 1.139A3.946 3.946 0 008.2 9.857v.643h7.5v-.643a3.946 3.946 0 00-1.107-2.718A3.73 3.73 0 0011.95 6z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Organization.displayName = 'OrganizationIcon';

export default Organization;
